/* Determine whether the user the required permission to access a specific feature */
export function hasUserPermission({ permissionCode, permissions }) {
  return permissions?.includes(permissionCode)
}

export function hasRole({ role, roles }) {
  return roles?.includes(role)
}
